import { Controller } from "@hotwired/stimulus"
import { Swiper } from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

export default class extends Controller {

  connect() {
    // Ignora o header carousel (gerenciado globalmente)
    if (this.element.id === 'header-carousel') {
      return
    }
    
    const firstImage = this.element.querySelector('.swiper-slide:first-child img');
    if (firstImage && !firstImage.complete) {
      firstImage.addEventListener('load', () => {
        requestAnimationFrame(() => {
          this.initializeSwiper()
        })
      });
    } else {
      requestAnimationFrame(() => {
        this.initializeSwiper()
      })
    }
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  initializeSwiper() {
    // Verifica se já existe um Swiper neste elemento
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }

    this.swiper = new Swiper(`[data-name=${this.element.dataset.name}]`, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      passiveListeners: true,
      observer: true,
      observeParents: true,

      ...(this.element.dataset.shouldbreakpoint !== "false" && {
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          1228: {
            slidesPerView: 3
          }
        },
      }),
      speed: 600,
      navigation: {
        nextEl: `.swiper-button-next.${this.element.dataset.name}`,
        prevEl: `.swiper-button-prev.${this.element.dataset.name}`
      },
      pagination: {
        el: `.swiper-pagination.${this.element.dataset.name}`,
      },
      loop: this.element.dataset.autoplay !== "false",
      ...(this.element.dataset.autoplay !== "false" && {
        autoplay: {
          delay: this.element.dataset.swipeTime || 3000,
          disableOnInteraction: false,
        }
      })
    });
  }
}